import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { interval, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
declare var $: any;

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.css']
})
export class AudioPlayerComponent implements OnInit {
  @Input() path: string;
  @Input() isAnsMedia: boolean = false;

  audioIsPlaying: Boolean = false;
  idKey: string;
  currentValue: string = "00:00";
  isMuted: boolean = false;
  circumFurance: number = 0;
  strokeDashoffset: number = 0;
  timeline: any;
  playhead: any;
  timelineWidth: any;
  isMouseMove: boolean = false;
  isMobile: boolean = false;
  progress1: any;
  isPreview: boolean;
  isButtonDown : boolean = false;
  isMobile1: boolean = false;

  constructor(private changeDetect: ChangeDetectorRef,
    private service: ParticipationDataService,
    private elementRef:ElementRef) { }

  ngOnInit() {
    this.idKey = Math.floor(Math.random() * Math.floor(Math.random() * Date.now())).toString();
    // this.path = 'includes/Angular/assets/mpfile.mp3';
    this.isMobile1 = this.service.getMobile();
    this.isPreview = this.service.GroupType.toUpperCase() == 'PREVIEW';
    var body = document.body;
    if (body.classList.contains('mobile-scroll')) {
      this.isMobile = true;
    }
  }

  ngAfterViewChecked() {
    if (!this.isAnsMedia || this.isMobile1) {
      var self = this;
      setTimeout(() => {
        self.currentTime1();
      }, 200);

      if (this.isMobile1 && this.isAnsMedia) {
        $('#' + self.idKey + "_audio_wrapper").closest('.answer-opt-image').addClass('bg-hide');
      }
    }
  }

  playAndPauseAudio() {
    var self = this;
    let player = $('#' + this.idKey + "_audio")[0];

    if (player.paused) {
      player.play();

      this.audioIsPlaying = true;
      this.checkPlayerStatus(player);
    } else {
      player.pause();
      this.audioIsPlaying = false;
    }
  }


  checkPlayerStatus(player) {
    if (this.audioIsPlaying) {
      let progress = player.currentTime / player.duration;
      this.setProgress(progress);
      var self = this;

      if (progress == 1) {
        self.audioIsPlaying = false;
        player.pause();
      }

      setTimeout(function () {
        self.checkPlayerStatus(player);
        self.currentTime();
      }, 33);
    }
  }

  setProgress(percent) {
    this.progress1=percent;
    percent *= 100;
    let player = $('#' + this.idKey + "_progress")[0];
    let radius = player.r.baseVal.value;
    let circumference = radius * 2 * Math.PI;
    this.circumFurance = circumference;
    this.strokeDashoffset = circumference - (percent / 100) * circumference;
    this.changeDetect.detectChanges();
  }

  forwordAudio() {
    let player = $('#' + this.idKey + "_audio")[0];
    let progress = player.currentTime / player.duration;

    if ((player.currentTime + 10) < player.duration) {
      player.currentTime += 10;
      progress = player.currentTime / player.duration;
    } else if ((player.currentTime + 10) >= player.duration) {
      player.currentTime = 0.0;
      player.play();
      this.audioIsPlaying = true;
      this.checkPlayerStatus(player);
      progress = 0;
    }
    this.currentTime();
    this.setProgress(progress);
  }

  backwordAudio() {
    let player = $('#' + this.idKey + "_audio")[0];
    let progress = player.currentTime / player.duration;

    if ((player.currentTime - 10) > 0) {
      player.currentTime -= 10;
      progress = player.currentTime / player.duration;
    } else if ((player.currentTime - 10) <= 0) {
      player.currentTime = 0.0;
      player.play();
      this.audioIsPlaying = true;
      this.checkPlayerStatus(player);
      progress = 0;
    }
    this.currentTime();
    this.setProgress(progress);
  }

  muteAndUnmute() {
    let player = $('#' + this.idKey + "_audio")[0];
    if (player.muted) {
      player.muted = false;
      this.isMuted = false;
    } else {
      player.muted = true;
      this.isMuted = true;
    }
  }

  muteAndUnmuteText(): string {
    let player = $('#' + this.idKey + "_audio")[0];
    if (player.muted) {
      return 'Unmute';
    } else {
      return 'Mute';
    }
  }

  currentTime(): any {
    let player = $('#' + this.idKey + "_audio")[0];
    const t: Observable<number> = interval(100);

    let value = player.currentTime;
    

    if (isNaN(value)) {
      this.currentValue =  '00:00';
    } else {
      this.currentValue = Math.floor(value / 60) + ":" + (value % 60 ? value.toFixed(0) % 60 : '00');
    }

    this.changeDetect.detectChanges();
  }

  /*New Audio Player Code*/
  audioPlay() {
    let player = $('#' + this.idKey + "_audio")[0];

    if (player.paused) {
      player.play();
     // $(".play-pause").empty().text("PAUSE");
      //this.timeCal();
      //this.initProgressBar();
      this.audioIsPlaying = true;
      this.checkPlayerStatus1(player);
    } else {
      player.pause();
      //$(".play-pause").empty().text("PLAY");
      this.audioIsPlaying = false;
    }

    //let player = $('#' + this.idKey + "_audio")[0];
    //alert(player);
     // player.play();

     // this.isPlaying = true;
  }

  checkPlayerStatus1(player) {
    if (this.audioIsPlaying) {
      let progress = player.currentTime / player.duration;
      this.timeCal(player);
      var self = this;

      if (progress == 1) {
        self.audioIsPlaying = false;
        player.pause();
        //$(".play-pause").empty().text("PLAY");
      }

      setTimeout(function () {
        self.checkPlayerStatus1(player);
        self.currentTime1();
      }, 33);
    }
  }

  timeCal(player1) {
    //let player1 = $('#' + this.idKey + "_audio")[0];
    var width = $('#' + this.idKey + '_timeline1').width();
    var length = player1.duration;
    var current_time = player1.currentTime;

    // calculate total length of value
    //var totalLength = this.calculateTotalValue(length);
    //console.info(totalLength);
    //$(".end-time").html(totalLength);

    // calculate current value time
   //this.currentValue = this.calculateCurrentValue(player1.duration - current_time);
    this.currentTime1();
    //$(".start-time").html(this.currentValue);

    var progressbar = document.getElementById(this.idKey + "_seekObj1");
    if((width * (player1.currentTime / player1.duration))>(width-7)){
      progressbar.style.marginLeft = (width-7) + "px";
    }else{
      if((width * (player1.currentTime / player1.duration))<=0){
        progressbar.style.marginLeft = 0 + "px";
      }else {
        progressbar.style.marginLeft = ((width * (player1.currentTime / player1.duration))) + "px";
      }
    }
    
    // $('#' + this.idKey + "_seekObj1").position().top;
    //$('#' + this.idKey + "_seekObj1").draggable();
   //$('#' + this.idKey + "_seekObj1").draggable({ axis:  progressbar.offsetLeft});
    //$('#' + this.idKey + "_seekObj1").draggable({"position":"fixed","left":progressbar.offsetLeft + "px","top":progressbar.offsetTop + "px"});
    //$('#' + this.idKey + "_seekObj1").draggable( "option", "cursorAt", { left: progressbar.offsetLeft, top: progressbar.offsetTop} );
    // $('#draggable').draggable({
    //   start: function () {
    //     $(this).css({ transform: "none", top:  progressbar.offsetTop+ "px", left:  progressbar.offsetLeft + "px" });
    //   }
    // });

    var progressbarfill = document.getElementById(this.idKey + "_audiofill");
    if((width * (player1.currentTime / player1.duration))>width){
      progressbarfill.style.width = width + "px";
    }else{
      progressbarfill.style.width = width * (player1.currentTime / player1.duration) + "px";
    }
    
  }

  calculateTotalValue(length) {
    var minutes = Math.floor(length / 60);
    var seconds_int = length - minutes * 60;
    if (seconds_int < 10) {
      console.info("here");
      seconds_int = 0 + seconds_int;
      console.info(seconds_int);
    }
    var seconds_str = seconds_int.toString();
    var seconds = seconds_str.substr(0, 2);
    var time = minutes + ':' + seconds;
    console.info(seconds_int)
    return time;
  }

    calculateCurrentValue(currentTime: any) {
    // let player = $('#' + this.idKey + "_audio")[0];
    // const t: Observable<number> = interval(100);

    // let value = player.currentTime;
    // this.currentValue = Math.floor(value / 60) + ":" + (value % 60 ? value.toFixed(0) % 60 : '00');

    // this.changeDetect.detectChanges();

    // let current_hour = (currentTime / 3600) % 24;
    // let current_minute = (currentTime / 60) % 60;
    // let current_seconds_long = currentTime % 60;
    // let current_seconds = current_seconds_long.toFixed();
    // let current_time = (current_minute < 10 ? "0" + current_minute : current_minute) + ":" + (parseInt(current_seconds) < 10 ? 0 + current_seconds : current_seconds);
    return Math.floor(currentTime / 60) + ":" + (currentTime % 60 ? currentTime.toFixed(0) % 60 : '00');
  }

  seek(event, isMouseMove: boolean = true) {
    let player = $('#' + this.idKey + "_audio")[0];
    this.timeline = document.getElementById(this.idKey + "_timeline1");
    this.playhead = document.getElementById(this.idKey + "_seekObj1");
    this.timelineWidth = this.timeline.offsetWidth - this.playhead.offsetWidth;
    player.currentTime = player.duration * this.clickPercent(event, this.timeline, this.timelineWidth);
    this.drag(event);

    if (isMouseMove) {
      this.isMouseMove = true;
    } else {
      this.isMouseMove = false;
    }
  }

  clickPercent(e, timeline, timelineWidth) {
    // let t= (e.clientX - this.getPosition(timeline)) / timelineWidth;
    if(this.isMobile){
      return ((e.targetTouches[0] ? e.targetTouches[0].pageX : e.changedTouches[e.changedTouches.length-1].clientX) - this.getPosition(timeline)) / timelineWidth;
    }else{
      return (e.clientX - this.getPosition(timeline)) / timelineWidth;
    }
  }

  getPosition(el) {
    return el.getBoundingClientRect().left;
  }

  mousedownin(){
    this.isButtonDown=true;
  }

  drag(e) {
    let player1 = $('#' + this.idKey + "_audio")[0];

    if(this.isMobile ){
      this.timeline = document.getElementById(this.idKey + "_timeline1");
      this.playhead = document.getElementById(this.idKey + "_seekObj1");
      this.timelineWidth = this.timeline.offsetWidth - this.playhead.offsetWidth;
    }

    //player1.removeEventListener("timeupdate", this.timeCal);
   // this.onplayhead = $(this).attr("id");
  // this.onplayhead = '#' + this.idKey + '_seekObj1';
    //this.playerId = '#' + this.idKey + "_audio";
    //var player = document.getElementById(this.playerId);
    //window.addEventListener('mousemove', this.dragFunc);
    //player.removeEventListener('timeupdate', this.timeUpdate);

    this.dragFunc(e);
    //this.timeUpdate(player1);
    this.timeCal(player1);
    //this.changeDetect.detectChanges();
    //this.currentTime();
  }

  dragFunc(e) {
    //var player = document.getElementById(this.onplayhead);
    this.timeline = document.getElementById(this.idKey + "_timeline1");


    if(this.isMobile){
      var newMargLeft = (e.targetTouches[0] ? e.targetTouches[0].pageX : e.changedTouches[e.changedTouches.length-1].pageX) - this.getPosition(this.timeline);
    }else{
      var newMargLeft = e.clientX - this.getPosition(this.timeline);
    }


    if (newMargLeft >= 0 && newMargLeft <= this.timelineWidth) {
      this.playhead.style.marginLeft = (newMargLeft -1) + "px";
      $(this.playhead).css('marginLeft', (newMargLeft -1) + "px");
    }

    if (newMargLeft < 0) {
      this.playhead.style.marginLeft = "0px";
      $(this.playhead).css('marginLeft', "0px");
    }

    if (newMargLeft > this.timelineWidth) {
      this.playhead.style.marginLeft = (this.timelineWidth -1) + "px";
      $(this.playhead).css('marginLeft', (this.timelineWidth -1) + "px");
    }

//var player = $('#' + this.idKey + "_audio")[0];
    //this.timeCal(player);
    //this.timeUpdate(player);
    //this.mouseUp(e);
  }

  mousemove(e){
    this.timeline = document.getElementById(this.idKey + "_timeline1");
      this.playhead = document.getElementById(this.idKey + "_seekObj1");
      this.timelineWidth = this.timeline.offsetWidth - this.playhead.offsetWidth;
    if(this.isButtonDown && this.timeline && this.timelineWidth){
      var player = $('#' + this.idKey + "_audio")[0];
      this.isMouseMove = false;
      player.currentTime = player.duration * this.clickPercent(e, this.timeline, this.timelineWidth);
      this.timeCal(player);
    }
  }

  mouseUpin() {
    this.isButtonDown=false;
  }

  mouseUp(e) {
    //if (this.onplayhead != null) {
      var player = $('#' + this.idKey + "_audio")[0];
      //window.removeEventListener('mousemove', this.dragFunc);
      this.isMouseMove = false;
      player.currentTime = player.duration * this.clickPercent(e, this.timeline, this.timelineWidth);
      //this.player1.addEventListener("timeupdate", this.timeCal);
      this.timeCal(player);
      //this.timeUpdate(player);
      //this.currentTime();
      //player.addEventListener('timeupdate', this.timeUpdate);
    // }
    // this.onplayhead = null;
  }

  currentTime1(): any {
    let player = $('#' + this.idKey + "_audio")[0];
    var value: number =0;
    if (player != null && player != undefined) {
      if(player.currentTime<0){
        value = player.duration;
      }else if(player.currentTime>player.duration){
        value = 0;
      }else{
        value = player.duration - player.currentTime;
      }
      

      if (isNaN(value)) {
        return '00:00';
      } else {
        this.currentValue = (Math.floor(value / 60) >= 10 ? Math.floor(value / 60) : "0" + Math.floor(value / 60) + ":" + (value % 60 ? (Math.round(value % 60) >= 10 ? Math.round(value % 60) : "0" + Math.round(value % 60)) : '00')).toString();
      }
      this.changeDetect.detectChanges();
    }
  }

  totalTime(): string {
    let player = $('#' + this.idKey + "_audio")[0];

    if (player != null && player != undefined) {
      let value = player.duration;

      if (isNaN(value)) {
        return '00:00';
      }
      return Math.floor(value / 60) + ":" + (value % 60 ? value.toFixed(0) % 60 : '00');
    }
  }

  timeUpdate(player) {
    var player2 = document.getElementById('#' + this.idKey + '_seekObj1');
    //var player = $('#' + this.idKey + "_audio")[0];
    var playPercent = this.timelineWidth * (player.currentTime / player.duration);
    player2.style.marginLeft = (playPercent - 1) + "px";
    // If song is over
    if (player.currentTime == player.duration) {
      player.pause();
    }
  }
}
